import i18n from "../../i18n/config";
import type { IntervalOptionType } from "../../TuvisSettings/types/IntervalOptionType";

export const INTERVAL_OPTIONS: IntervalOptionType[] = [
  {
    label: i18n.t("usersDeactivationPage.never"),
    value: "never",
  },
  {
    label: i18n.t("usersDeactivationPage.Every_1_hour"),
    value: "1h",
  },
  {
    label: i18n.t("usersDeactivationPage.Every_6_hour"),
    value: "6h",
    description: i18n.t("usersDeactivationPage.Every_6_hour_desc"),
  },
  {
    label: i18n.t("usersDeactivationPage.Every_12_hour"),
    value: "12h",
    description: i18n.t("usersDeactivationPage.Every_12_hour_desc"),
  },
  {
    label: i18n.t("usersDeactivationPage.Every_24_hour"),
    value: "24h",
    description: i18n.t("usersDeactivationPage.Every_24_hour_desc"),
  },
  {
    label: i18n.t("usersDeactivationPage.Every_2_days"),
    value: "2d",
    description: i18n.t("usersDeactivationPage.Every_2_days_desc"),
  },
  {
    label: i18n.t("usersDeactivationPage.Every_7_days"),
    value: "7d",
    description: i18n.t("usersDeactivationPage.Every_7_days_desc"),
  },
];
